// extracted by mini-css-extract-plugin
export default {"component":"I0zBiZM1","time-left":"i4QX0O7V"};